import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';
import { List } from 'lodash';

interface LabBackupInfoState {
    CheckScheduleExist?:Boolean,
    Schedule?:List<JSON>,
    AutoBackupSettings?:List<JSON>,
    CheckPath?:String,
    BackupPath?:String,
    CheckSMSService?:Boolean,
    CheckSMSServiceType?:String,

}
  
const initialState:LabBackupInfoState = {
    CheckScheduleExist:false,
    Schedule:[],
    AutoBackupSettings:[],
    CheckPath:"",
    BackupPath:"",
    CheckSMSService:false,
    CheckSMSServiceType:""
}

export const LabBackupInfoSlice = createSlice({
    name:"backupInfo",
    initialState,
    reducers:{
        UpdateLabBackupInfo: (state,action) => {
            state.CheckScheduleExist = action.payload.CheckScheduleExist;
            state.Schedule = action.payload.Schedule;
            state.AutoBackupSettings = action.payload.AutoBackupSettings;
            state.CheckPath = action.payload.CheckPath;
            state.BackupPath = action.payload.BackupPath;
            state.CheckSMSService = action.payload.CheckSMSService;
            state.CheckSMSServiceType = action.payload.CheckSMSServiceType;
        },
        AddLabBackupInfo: (state,action) => (
            initialState
        ),
        EditLabBackupInfo: (state,action) => (
            initialState
        ),
        RemoveLabBackupInfo: (state,action) => (
            initialState
            )
    }
})

export const {UpdateLabBackupInfo,AddLabBackupInfo,EditLabBackupInfo,RemoveLabBackupInfo} = LabBackupInfoSlice.actions

export const selectLabBackupInfo = (state: RootState) => state.backupInfo

export default LabBackupInfoSlice.reducer;